import ApiModel               from '@widesk-core/models/ApiModel';
import React                  from 'react';
import { Action }             from '@widesk-ui/components/ButtonActions';
import { Modal }              from '@widesk-ui/components/modal/Modal';
import { ModalProps }         from '@widesk-ui/components/modal/Modal';
import { WithLocalizedLabel } from '@widesk-core/mixins/ApiModelLocalizedLabel';
import uniqueId               from 'lodash/uniqueId';
import { CopyOutlined }       from '@ant-design/icons';

type LocalizedApiModel = ApiModel & WithLocalizedLabel;
type LocalizedApiModelClass = typeof ApiModel & WithLocalizedLabel;

type DuplicateOptions<MC extends LocalizedApiModelClass> = {
	modelName?: string;
	wizard?: boolean;
	hideModelName?: boolean;
	modalProps?: Partial<ModalProps> | ((model: InstanceType<MC>) => Partial<ModalProps>),
	actionProps?: Partial<Action>,
};

const actionDuplicateModel = <M extends LocalizedApiModel, MC extends LocalizedApiModelClass>(
	model: M,
	modelDuplicateClass: MC,
	form: React.ReactNode | ((model: InstanceType<MC>) => React.ReactNode),
	options?: DuplicateOptions<MC>,
): Action => {
	const label = `Dupliquer` + (options?.hideModelName ? '' : ` - ${options?.modelName || model.localize()}`);

	return {
		label,
		icon: <CopyOutlined />,
		onClick: async () => {
			const model = new (modelDuplicateClass as any)() as InstanceType<MC>;

			const children = typeof form === 'function' ? form(model) : form;
			const modalOptions = typeof options?.modalProps === 'function'
				? options?.modalProps(model)
				: options?.modalProps;

			return Modal.open({
				title: label,
				children,
				okText: 'Dupliquer',
				okButtonProps: {
					htmlType: 'submit',
					form: uniqueId(),
				},
				...(() => {
					// Suppression du footer de la modale (si on est dans un wizard) et largeur par défaut à 1000
					if (options?.wizard) return { footer: null, width: 1000 };
					return {};
				})(),
				...modalOptions,
			});
		},
		...options?.actionProps,
	};
};

export default actionDuplicateModel;
